import React from 'react';
import Invoice from 'src/models/leasing/Invoice';
import Card, { CardAction } from 'src/components/common/Card.redesign';

interface IInvoiceCard {
    invoice: Invoice;
    index: number;
    onInvoiceAction: (action: string) => void;
    convertToCurrency: (value: number) => string;
}

const InvoiceCard = (props: IInvoiceCard) => {
    let invoiceActions: CardAction[] = [
        { text: 'Create Check', action: () => props.onInvoiceAction('Create Check') },
        { text: 'Manage Invoice', action: () => props.onInvoiceAction('Manage Invoice') },
        { text: 'Manage Checks', action: () => props.onInvoiceAction('Manage Checks') },
    ];

    if (props.invoice?.invoiceStatus !== 'Void' && props.invoice?.invoiceStatus !== 'Posted') {
        invoiceActions.push({ text: 'Post Invoice', action: () => props.onInvoiceAction('Post Invoice') });
        invoiceActions.push({ text: 'Void Invoice', action: () => props.onInvoiceAction('Void Invoice') });
    }

    const actions: CardAction[] = invoiceActions;

    return (
        <Card
            className="small-input"
            contextActions={actions}
            newContext={true}
            showMenu={true}
            badge={`Status: ${props.invoice.invoiceStatus || 'Pending'}`}
        >
            <div style={{ display: 'flex' }}>
                <div className="mr-2" style={{ width: '100%' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ padding: '1rem', width: '15%' }}>
                            <div>{props?.invoice?.invoiceNumber ? props.invoice.invoiceNumber : 'N/A'}</div>
                        </div>
                        <div style={{ padding: '1rem', width: '15%' }}>
                            <div>{props.convertToCurrency(props?.invoice?.bonusAmount)}</div>
                        </div>
                        <div style={{ padding: '1rem', width: '15%' }}>
                            <div>{props.convertToCurrency(props?.invoice?.rentAmount)}</div>
                        </div>
                        <div style={{ padding: '1rem', width: '15%' }}>
                            <div>{props.convertToCurrency(props?.invoice?.recordingFee)}</div>
                        </div>
                        <div style={{ padding: '1rem', width: '15%' }}>
                            <div>{props.convertToCurrency(props?.invoice?.bankCharge)}</div>
                        </div>
                        <div style={{ padding: '1rem', width: '15%' }}>
                            <div>{props.convertToCurrency(props?.invoice?.otherFee)}</div>
                        </div>
                        <div style={{ padding: '1rem', width: '10%' }}>
                            <div>{props.convertToCurrency(props?.invoice?.invoiceTotal)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default InvoiceCard;



// WEBPACK FOOTER //
// ./src/components/invoicing/components/InvoiceCard.redesign.tsx